export default function determineBasketError({ props, state }) {
  const size = state.get(`${props.path}.form.${props.name}.maxValue`)
  return { error: props.failedRule, params: { size } }
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/determineBasketError.js